import { faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faHome, faMailBulk, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import styles from './footer.scss';

type Props = {
  id: string;
};

const Footer: React.FC<Props> = (props) => {
  const renderLeft = () => {
    return (
      <>
        <div className={styles['address']}>
          <FontAwesomeIcon icon={faHome} fixedWidth />
          <span>
            <p>Bradford</p>
            <p>West Yorkshire</p>
            <p>England</p>
          </span>
        </div>

        <div className={styles['phone']}>
          <FontAwesomeIcon icon={faPhone} fixedWidth />
          <span>
            <p>(+44) 07716 978 676</p>
          </span>
        </div>

        <div className={styles['email']}>
          <FontAwesomeIcon icon={faMailBulk} fixedWidth />
          <span>
            <a href="mailto:khanh@r2v2.co.uk?subject=Hello!">khanh@r2v2.co.uk</a>
          </span>
        </div>
      </>
    );
  };

  const renderRight = () => {
    return (
      <>
        <div className={styles['company']}>
          <h4>R2V2 is my personal space on the web.</h4>
          <p>I am a father, a husband, a brother and a</p>
          <p>passionate frontend developer...</p>
          <p>...roughly in that order.</p>
        </div>

        <div className={styles['social']}>
          <a href="https://www.linkedin.com/in/khanh-tu-60026a2/" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
          <a href="https://www.instagram.com/r2v2.co.uk/" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </div>
      </>
    );
  };

  return (
    <div id={props.id} data-testid={props.id} className={styles['footer']}>
      <div className={styles['container']}>
        <div className={styles['left']}>{renderLeft()}</div>
        <div className={styles['right']}>{renderRight()}</div>
      </div>
    </div>
  );
};

export default Footer;
